import React from "react";

const routes = [
  {
    title: "Pune to Mumbai Airport Cab Service",
    description:
      "Book reliable one-way or round trip cabs from Pune to Mumbai International or Domestic Airport with 24/7 availability.",
  },
  {
    title: "Pune to Shirdi Taxi Booking",
    description:
      "Comfortable outstation cab service to Shirdi for temple visits, Sai Baba Darshan, or overnight stays with professional drivers.",
  },
  {
    title: "Pune to Mahabaleshwar Cab Service",
    description:
      "Affordable Pune to Mahabaleshwar taxi for weekend getaways, family trips, and sightseeing with AC cabs and courteous drivers.",
  },
  {
    title: "Pune to Nashik Outstation Cabs",
    description:
      "Fast and safe Pune to Nashik cab booking for business, pilgrimages, or vineyard visits. Doorstep pickup and flexible timings.",
  },
  {
    title: "Pune to Aurangabad Cab Service",
    description:
      "Book cabs to Aurangabad for Ajanta & Ellora caves, family trips, or business travel. Choose from Sedans, SUVs, or Tempo Travellers.",
  },
  {
    title: "Pune to Kolhapur Taxi Service",
    description:
      "Travel from Pune to Kolhapur with Sai Trupti Cabs — trusted service for Darshan, business visits, or family travel.",
  },
];

const TopRoutesSection = () => {
  return (
    <section className="toproutes-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-title-box text-center">
          <span className="sub-title">TOP ROUTES</span>
          <h2 className="title">Book Popular Cab Routes From Pune</h2>
          <p className="subtitle">
            Sai Trupti Cabs offers trusted one-way, round-trip, and outstation
            cab services from Pune to major cities across Maharashtra.
          </p>
        </div>

        {/* Routes Grid */}
        <div className="routes-grid">
          {routes.map((route, index) => (
            <div key={index} className="route-card">
              <h4 className="route-title">{route.title}</h4>
              <p className="route-desc">{route.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopRoutesSection;
